import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, FileText, ShoppingCart, Target, Activity, Utensils } from 'lucide-react';
const deliverables = [{
  icon: FileText,
  title: 'El Protocolo Maestro PDF',
  desc: 'El cronograma minuto a minuto del día de reseteo.'
}, {
  icon: ShoppingCart,
  title: 'La Lista de Compras SOS',
  desc: 'Los únicos 6 ingredientes que necesitas para desinflamarte hoy.'
}, {
  icon: Target,
  title: "El Mapa de Alimentos 'Gatillo'",
  desc: 'Identifica qué alimentos específicos te hinchan como un globo.'
}, {
  icon: Activity,
  title: 'Rutina AM/PM de 5 Minutos',
  desc: 'Movimientos mecánicos para mover el gas atrapado hacia la salida.'
}, {
  icon: Utensils,
  title: 'Guía de Supervivencia en Restaurantes',
  desc: 'Cómo comer fuera sin inflamar tu abdomen al instante.'
}];
export function WhatYouGet() {
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-161">
      <div className="max-w-4xl mx-auto" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-163">
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-164">
            Lo que obtienes hoy
          </h2>
          <div className="w-24 h-1 bg-forest mx-auto rounded-full" data-id="element-165"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-166">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-forest-50 flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-167">
              <div className="bg-forest-50 p-3 rounded-xl shrink-0" data-id="element-168">
                <item.icon className="w-6 h-6 text-forest" data-id="element-169" />
              </div>
              <div data-id="element-170">
                <h3 className="text-xl font-bold text-charcoal mb-1 flex items-center gap-2" data-id="element-171">
                  {item.title}
                  <CheckCircle2 className="w-5 h-5 text-forest hidden sm:inline-block" data-id="element-172" />
                </h3>
                <p className="text-charcoal-light" data-id="element-173">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}